import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Papir ali elektroni",
  "description": "",
  "published": "2007-03-20T00:00:00.000Z",
  "redirect_from": ["/blog/papir-ali-elektroni/swizec/256"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Zelo sem se veselil napisati recenzijo`}<a parentName="p" {...{
        "href": "http://www.steampunkmagazine.com/"
      }}>{` SteamPunk Magazine`}</a>{` v tale blog, ampak se je tako pripetilo, da je se nisem uspel prebrati, zatorej lahko omenim le, da je prav vsecno zgrajena in vsebuje nekaj trdnega pisanja in zanimivih clankov vrednih ogleda. Celo tako je dobra, da mi je bila za krajsi cas odtujena ... Ce se vam po glavi pletejo misli o branju te revije, si jo kupite, ker ji elektroni res ne delajo pravice.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      